<script lang="ts">
 
  export let isPaused = false;
  export let rootElement;
   
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 2.5s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
    
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
  }

  @keyframes pushup-1 {
    0% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #pushup-1 {
    animation-name: pushup-1;
  }
  @keyframes pushup-2 {
    0% {
      opacity: 0;
    }
    50%,
    100% {
      opacity: 1;
    }
  }
  #pushup-2 {
    animation-name: pushup-2;
  }
  }
</style>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 734.9 313.6" height="100%" width="100%">
  <g class:paused={isPaused}>
  <g class="shapes" bind:this={rootElement}>
    <g id="pushup-2">
      <path
        fill="var(--hair)"
        d="M735 222c-5 8-4 17-7 26-2 4 1 10-5 12s-10-3-14-6l5-11c1-5 3-10-6-8a4 4 0 0 1-5-2c-2-4-5-4-9-2-4 1-9 1-14-1a6 6 0 0 1-3-6c1-4 4-3 6-3h6c3 0 6-1 8-5 1-3-1-7-3-10-3-3-8-4-12-4-11 0-17-6-21-16 11-9 26-11 40-12 6-1 12-3 18 0 7 3 13 8 16 15ZM62 222c-5 7-7 15-10 23-1 4-1 6 4 8a40 40 0 0 1 8 4c7 4 7 10 0 14-10 6-34 4-42-5-5-6-6-15-6-23 0-14 0-28-5-41-1-2-1-4-3-5v-13c15-3 31-3 47-3a2 2 0 0 1 2 2c-9-2-14 4-17 12l-3 4c-5 7-3 11 5 21 5 6 9 9 16 2h4Z"
      />
      <path
        fill="var(--pants)"
        d="M438 235c-9 3-15 11-25 12-23 1-45 4-68 2-15-1-29 2-44 4-11 2-13 1-17-10l-2-10c1-18-1-37-3-55 3-5 8-4 13-5 3-1 7-1 8-6 1-3 4-3 6-4l27-5a274 274 0 0 0 64-17 63 63 0 0 1 37-4c6 1 13 3 18 8-5 10-7 21-4 32v15a342 342 0 0 0-10 43Z"
      />
      <path
        fill="var(--flesh)"
        d="M279 178c2 18 4 37 3 55-21-4-42 0-63-3a50 50 0 0 1-9-2c-21-8-44-5-65-9-13-3-26-2-38-2-13-2-25 0-37 2-3 1-6 1-8 3h-4c-7 7-11 4-16-2-8-10-10-14-5-21l3-4c3-8 8-14 17-12h11a339 339 0 0 0 47-4c15 0 31-2 47-4 24-3 48-5 72 1 15 4 30 6 45 2Z"
      />
      <path
        fill="var(--shirt)"
        d="M438 235a342 342 0 0 1 10-43v-15c-3-11-1-22 4-32 6 3 13 3 18 9h3c11-3 21 5 32 1 10 1 20-6 31-3-1 3-5 1-6 4l-6 19c-2 19 3 36 7 54 2 9 5 17 5 26a273 273 0 0 0-43 3c-15 2-29-5-44-5l-5-1c-6 0-7-3-6-8 0-3 2-6 0-9Z"
      />
      <path
        fill="var(--flesh)"
        d="M536 255c0-9-3-17-5-26-4-18-9-35-7-54l6-19c1-3 5-1 6-4-11-3-21 4-31 3l2-8c2-4 4-8 10-8 15 0 31 0 45 8-1 2-4 3 1 4 12 2 25 3 35 12 6 5 9 9 6 18l-5 12c-1 4-1 10-6 11-4 2-5 4-7 7-5 7-11 8-18 4-4-2-6-1-6 3l-3 15c-1 7-3 15 2 22-1 6 2 8 8 8a227 227 0 0 1 55 10c3 1 5 2 5 5l-5 4c-24 5-48 0-72 1-5 0-8-3-9-8a88 88 0 0 0-7-20Z"
      />
      <path
        fill="var(--shirt)"
        d="M561 255c-5-7-3-15-2-22l3-15c0-4 2-5 6-3 7 4 13 3 18-4 2-3 3-5 7-7 5-1 5-7 6-11l5-12c3-9 0-13-6-18-10-9-23-10-35-12-5-1-2-2-1-4 14 1 29 2 42 7 17 6 31 16 43 29a148 148 0 0 1-9 44 133 133 0 0 1-26 24c-9 7-20 7-31 6l-20-2Z"
      />
      <path
        fill="var(--flesh)"
        d="M638 227a148 148 0 0 0 9-44c4 4 9 3 14 3 4 10 10 16 21 16 4 0 9 1 12 4 2 3 4 7 3 10-2 4-5 5-8 5h-6c-2 0-5-1-6 2a6 6 0 0 0 3 7c5 2 9 2 14 1 4-2 7-3 9 2a4 4 0 0 0 5 2c9-2 7 3 6 8l-5 11c-12 2-26-2-37 7l-4 2c-5-6-13-3-18-8l-2-2c-13-1-9-9-8-17 1-3 2-7-2-9Z"
      />
      <path
        fill="var(--hair)"
        d="M115 179a339 339 0 0 1-47 4c-1-8 1-10 10-10 12 0 25 0 37 6ZM70 219c12-2 24-4 37-2l-5 7c-7 11-7 12 4 19 2 2 4 4 4 7-1 3-3 5-5 6-12 4-23 2-34-2-4-2-5-6-5-11l4-24Z"
      />
    </g>
    <g id="pushup-1">
      <path
        fill="var(--shirt)"
        d="M509 111c-22 6-44 13-65 23-6 3-12-1-18 1l-23 4c-6 0-8-1-8-7l-2-8c-2-16-5-32-4-48a16 16 0 0 0-3-8c-6-11-8-23-7-36a121 121 0 0 0 29-6 9 9 0 0 1 2-1c25-1 46-13 68-20a46 46 0 0 1 13-2c3 0 5 0 6-3h48c3 6 9 3 14 4 14 3 24 13 38 17l3 7-6 26c-2 12-5 25-4 37-5 11-4 22-6 33-1 6 0 13-6 17-3-4-10-5-11-4-10 4-19 0-29 2-2-2-5-3-7 0-4-1-4-5-4-8a177 177 0 0 1 0-17c1-7-3-8-7-6s-8 1-11 3Z"
      />
      <path
        fill="var(--hair)"
        d="m600 28-3-7c16-6 32-16 49-20l1-1h12c24 5 26 25 30 44l4 28c2 9-1 13-10 12l-11-4 3-9c2-8-1-11-9-8-4 1-6 0-8-3-3-4-8-6-14-5l-10-1c-4-1-7-4-8-8-1-5 4-5 6-6 6-3 10-7 6-13-3-6-8-4-13-2-8 3-16 9-25 3Z"
      />
      <path
        fill="var(--pants)"
        d="M379 32c-1 13 1 25 7 36a16 16 0 0 1 3 8c-1 16 2 32 4 48a9 9 0 0 0-6 4c-6 10-15 15-25 18-14 5-27 11-41 14a274 274 0 0 0-62 23c-4 2-7 1-9-2l-10-14c1-3 8-3 4-9-9-13-16-28-22-43a5 5 0 0 1 3-5c16-8 30-21 46-30a578 578 0 0 0 55-37c16-11 34-17 53-11Z"
      />
      <path
        fill="var(--flesh)"
        d="M222 115c6 15 13 30 22 43 4 6-3 6-4 9-9 1-16 6-25 8-14 4-28 4-42 8l-22 11-32 12c-11 3-22 4-31 11-7 5-16 9-20 17-5-1-8 5-12 5-6-2-13-3-19-6-6-5-8-11-3-18 3-3 5-6 4-10 14-2 25-11 36-18l2-3c14-5 27-11 34-25a9 9 0 0 0 7-2c12-8 27-11 38-19 20-16 42-22 67-23ZM538 139c10-2 19 2 29-2 1-1 8 0 11 4-4 38-9 75-16 112l-2 20c-1 7 0 8 7 7 4-1 10-6 8 5 0 2 4 2 5 2 9-1 17 2 25 2 9 0 12 7 18 11 3 2 0 5 0 7 0 3-3 3-5 3-4 0-9-4-11 3h-8c-11-3-22-3-33-3a50 50 0 0 1-14-1c-11-3-14-7-14-18v-50c0-7-1-11-9-11l-8-2c-11-2-17-9-17-20-1-25 2-49 4-73 0-8 2-16 1-24 3-2 7-1 10-3 5-3 9-2 8 6a177 177 0 0 0 0 17c0 3 0 7 4 8l-9 50c-1 5-2 10 0 14 2 6 7 6 12 6s2-5 2-8c0-21 3-42 2-62Z"
      />
      <path
        fill="var(--hair)"
        d="M38 205c1 4-1 7-4 10-5 7-3 13 3 18 6 3 13 4 19 6 4 0 7-6 12-5 3 2 1 4 0 5-7 8-2 17 0 25 1 2 3 2 4 2 7 1 14 4 21 7s7 11 1 14c-14 8-30 13-47 9-11-3-19-9-23-21-5-14-13-26-19-39l-5-11c-1-5 1-8 5-12 10-9 22-5 33-8Z"
      />
      <path
        fill="var(--flesh)"
        d="M600 28c9 6 17 0 25-3 5-2 10-4 13 2 4 6 0 10-6 13-2 1-7 1-6 6 1 4 4 7 8 8l10 1c6-1 11 1 14 5 2 3 4 4 8 3 8-3 11 0 9 8l-3 9c-9 3-16 9-26 9-4 0-8 5-11 8s-6 5-10 2l-2-2c-8 4-15-1-21 0-6 0-9-2-12-6-1-12 2-25 4-37l6-26Z"
      />
      <path
        fill="var(--hair)"
        d="M88 217c9-7 20-8 31-11-3 8 0 12 7 15a25 25 0 0 1 6 3c6 4 5 11-1 13a50 50 0 0 1-28 4 12 12 0 0 1-10-9l-5-15ZM110 159c-7 14-20 20-34 25-5-16-3-18 13-22 6-2 13-2 19-6 2-2 2 1 2 3Z"
      />
    </g>
  </g>
</g>
{#if isPaused}
<svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
{/if}
</svg>
